import styled, { css } from 'styled-components';

const Footer = styled.div`
  display: none;

  ${props => props.property === "true" && css`
    display: block;
  `}

  ${props => props.property === "false" && css`
    display: none;
  `}
`;

export { Footer }
